import _ from 'underscore'
import TemplateView from '../TemplateView'
import {BalanceFormatter} from '../util/BalanceFormatter'

export const BalanceHistory = {
    TableRows: {
        AUTOMATIC_BALANCE_LIMIT_RECORD: 'AUTOMATIC_BALANCE_LIMIT_RECORD',
        AUTOMATIC_BALANCE_RESET_RECORD: 'AUTOMATIC_BALANCE_RESET_RECORD',
        AUTOMATIC_BALANCE_ACCRUE_RECORD: 'AUTOMATIC_BALANCE_ACCRUE_RECORD',
        MANUAL_INCREASE_RECORD: 'MANUAL_INCREASE_RECORD',
        MANUAL_DECREASE_RECORD: 'MANUAL_DECREASE_RECORD',
        MANUAL_SET_RECORD: 'MANUAL_SET_RECORD',
        LEAVE_TIME_COMPLETED_RECORD: 'LEAVE_TIME_COMPLETED_RECORD'
    },

    BalanceTypes: {
        SICK: "sick",
        PTO: "pto"
    }
};

BalanceHistory.Table = function($containerEl, countWorkHoursPerDay, showBalanceInHours)
{
    TemplateView.call(this, $containerEl);
    this.balanceFormatter = new BalanceFormatter().init( countWorkHoursPerDay, showBalanceInHours  );
};

BalanceHistory.Table.prototype = _.create(TemplateView.prototype, {

    html: "<div class='balanceHistoryTableContainer <%=balanceTypeClass%>'>" +
         "  <table class='balanceHistoryTable display-for-print dataTable' cellspacing='0' cellpadding='0'><thead></thead><tbody class='rows'></tbody></table>" +
         "</div>",

    updateOnInit: false,

    afterRender: function()
    {
        this.$balanceRows = this.find(".balanceHistoryTable tbody");
        this.renderTHead();
        this._createRows(this.$balanceRows, this.getBalanceModels());
    },

    renderTHead: function()
    {
        new BalanceHistory.Table.HeadRow(this.find(".balanceHistoryTable thead")).init();
    },
    
    update: function()
    {
        this.$balanceRows.empty();

        this._createRows(this.$balanceRows, this.getBalanceModels());
    },

    _createRows: function($containerEl, models)
    {
        var balanceType = this.getBalanceType();
        var balanceFormatter = this.balanceFormatter;

        if (_.isEmpty(models))
        {
            new BalanceHistory.Table.NoLeaveTimeRow($containerEl, balanceType).init();
            return;
        }

        _.each(models, function(model)
        {
            switch (model.type)
            {
                case BalanceHistory.TableRows.AUTOMATIC_BALANCE_ACCRUE_RECORD:
                    new BalanceHistory.Table.AutoAdjustmentRow.Accrue($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.AUTOMATIC_BALANCE_LIMIT_RECORD:
                    new BalanceHistory.Table.AutoAdjustmentRow.Limit($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.AUTOMATIC_BALANCE_RESET_RECORD:
                    new BalanceHistory.Table.AutoAdjustmentRow.Reset($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.LEAVE_TIME_COMPLETED_RECORD:
                    new BalanceHistory.Table.LeaveTimeCompletedRow($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.MANUAL_INCREASE_RECORD:
                    new BalanceHistory.Table.ManualAdjustmentRow.Increase($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.MANUAL_DECREASE_RECORD:
                    new BalanceHistory.Table.ManualAdjustmentRow.Decrease($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.MANUAL_SET_RECORD:
                    new BalanceHistory.Table.ManualAdjustmentRow.ManualSet($containerEl, balanceType, model, balanceFormatter).init();
                    break;
            }
        })
    },

    getBalanceModels: function()
    {
    //    abstract
    },

    getBalanceType: function()
    {
    //    abstract
    }
});


// WEBPACK FOOTER //
// ./web/js/balanceHistory/BalanceHistoryTable.js